import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { loaderActions } from "../../../_actions/loader.actions";
import "../../../assets/css/master.css";
import CommonFilter from '../../../customControl/CommonFilter';
import CustomTable from '../../../customControl/CustomTable';
import { getAllData, verifytoken, } from '../../../services/ApiCallingUserServices';
import { userrights } from '../../commonClass/CommonInterfaceTypes';
import { formatDateRequire, generatePDF, ToolTip } from '../../commonClass/CommonValidation';
import { ExportExcel } from '../../commonClass/ExportExcel';
import { ClearLocalStorage } from '../../commonClass/Session';


const SupplierList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [supplierList, setSupplierList] = useState<any>([]);

    const [filteritems, setFilterItems] = useState<any>([]);
    const [searchby, setSerachBy] = useState<any>('All');
    const [searchvalue, setSearchValue] = useState('');
    const menuItem = useSelector((store: any) => store.menuitems.menu);
    const user = useSelector((store: any) => store.userstatus.tba);
    const [userRights, setUserRights] = useState<userrights>();


    useEffect(() => {
        //check for rights
        if (user) {
            const pathname = window?.location?.pathname?.toLowerCase()
            const hasRights: userrights = user?.find((fil: any) => fil?.PageLink?.toLowerCase() === pathname)
            setUserRights(hasRights)
            if (!hasRights?.URightView) {
                navigate('/dashboard');
            }
        }
    }, [user]);

    const getallsupplier = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            dispatch(loaderActions.start());
            const allsupplier = await getAllData('/midoffice/v1/getallsupplier');
            allsupplier?.data?.map((obj: any) => {
                obj.createdOn = formatDateRequire(obj?.createdDate)
                obj.Active = obj.isActive ? 'Active' : 'InActive'
                return obj;
            })
            setSupplierList(allsupplier?.data ? allsupplier?.data : []);
            setFilterItems(allsupplier?.data ? allsupplier?.data : []);
            dispatch(loaderActions.end());
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }
    const columns = [
        {
            name: 'Continent',
            key: 'continentName',
            sortable: true,
            float: "left",
            reorder: true,
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.continentName,
            format: (data: any) => <ToolTip data={data?.continentName} />
        },
        {
            name: 'Country',
            key: 'countryName',
            sortable: true,
            float: "left",
            reorder: true,
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.countryName,
            format: (data: any) => <ToolTip data={data?.countryName} />
        },
        {
            name: 'Region',
            key: 'regionName',
            sortable: true,
            float: "left",
            reorder: true,
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.regionName,
            format: (data: any) => <ToolTip data={data?.regionName} />
        },
        {
            name: 'State',
            key: 'stateName',
            sortable: true,
            float: "left",
            reorder: true,
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.stateName,
            format: (data: any) => <ToolTip data={data?.stateName} />
        },
        {
            name: 'City',
            key: 'city',
            sortable: true,
            float: "left",
            reorder: true,
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.city,
            format: (data: any) => <ToolTip data={data?.city} />
        },
        {
            name: 'Company Name',
            key: 'supplierName',
            sortable: true,
            float: "left",
            reorder: true,
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.supplierName,
            format: (data: any) => <ToolTip data={data?.supplierName} />
        },
        {
            name: 'Supplier Code',
            key: 'supplierCode',
            sortable: true,
            float: "left",
            reorder: true,
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.supplierCode,
            format: (data: any) => <ToolTip data={data?.supplierCode} />
        },
        {
            name: 'State of Incorporation',
            key: 'hoName',
            sortable: true,
            float: "left",
            reorder: true,
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.hoName,
            format: (data: any) => <ToolTip data={data?.hoName} />
        },
        {
            name: 'Office No.',
            key: 'officeNo',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.officeNo,
            format: (data: any) => <ToolTip data={data?.officeNo} />
        },
        {
            name: 'House No.',
            key: 'houseNo',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.houseNo,
            format: (data: any) => <ToolTip data={data?.houseNo} />
        },
        {
            name: 'Building Name',
            key: 'buildingName',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.buildingName,
            format: (data: any) => <ToolTip data={data?.buildingName} />
        },
        {
            name: 'Building No.',
            key: 'buildingNo',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.buildingNo,
            format: (data: any) => <ToolTip data={data?.buildingNo} />
        },
        {
            name: 'Street',
            key: 'street',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (datadata: any) => datadata?.street,
            format: (data: any) => <ToolTip data={data?.street} />
        },
        {
            name: 'Locality',
            key: 'locality',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (datadata: any) => datadata?.locality,
            format: (data: any) => <ToolTip data={data?.locality} />
        },
        {
            name: 'Landmark',
            key: 'landmark',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (datadata: any) => datadata?.landmark,
            format: (data: any) => <ToolTip data={data?.landmark} />
        },
        {
            name: 'Pincode',
            key: 'pincode',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.pincode,
            format: (data: any) => <ToolTip data={data?.pincode} />
        },
        {
            name: 'Website',
            key: 'website',
            sortable: true,
            float: "left",
            reorder: true,
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.website,
            format: (data: any) => <ToolTip data={data?.website} />
        },
        {
            name: 'About Company',
            key: 'aboutSupplier',
            sortable: true,
            float: "left",
            minWidth: "300px",
            maxWidth: "500px",
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.aboutSupplier,
            format: (data: any) => <ToolTip data={data?.aboutSupplier} />
        },
        {
            name: 'Incorporation No.',
            key: 'incorporationNo',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.incorporationNo,
            format: (data: any) => <ToolTip data={data?.incorporationNo} />
        },
        {
            name: 'PAN Number',
            key: 'panNo',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.panNo,
            format: (data: any) => <ToolTip data={data?.panNo} />
        },
        {
            name: 'GSTN Number',
            key: 'gstnNo',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.gstnNo,
            format: (data: any) => <ToolTip data={data?.gstnNo} />
        },
        {
            name: 'Active',
            key: 'Active',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.Active,
            format: (data: any) => <ToolTip data={data?.Active} />
        },
        {
            name: 'Created Date',
            sortable: true,
            float: "left",
            isSearch: false,
            isExport: false,
            selector: (data: any) => new Date(data?.createdDate),
            // format: (data: any) => data?.createdDate,,
            format: (data: any) => <ToolTip data={data?.createdOn} />
        },
        {
            name: 'Edit',
            selector: (data: any) => <button type='button' className='border-0 p-0 set_disableclr' disabled={!userRights?.URightEdit}><i className="fa fa-edit" onClick={() => handleEdit(data?.supplierId)}></i></button>
        },
        {
            name: 'View',
            selector: (data: any) => <i className="fa fa-eye" onClick={() => handleView(data?.supplierId)}></i>
        }
    ];

    useEffect(() => {
        async function fetchData() {
            dispatch(loaderActions.start())
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                Promise.allSettled([
                    getallsupplier()
                ])
                dispatch(loaderActions.end())
            }
            else {
                dispatch(loaderActions.end());
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
        fetchData();
    }, [])


    const handleOpen = () => {
        navigate('/supplier-management', { state: { disabled: false, editdisabled: false, cleardisabled: false, type: 'Add', Id: 0, supplierList: filteritems } });
    }
    const handleEdit = (id: number) => {
        navigate('/supplier-management', { state: { disabled: false, editdisabled: true, cleardisabled: true, type: 'Edit', Id: id, supplierList: filteritems } });
    }
    const handleView = (id: number) => {
        navigate('/supplier-management', { state: { disabled: true, editdisabled: true, cleardisabled: true, type: 'View', Id: id, supplierList: filteritems } });
    }

    const PdfExport = () => {
        const keys = columns?.filter((fil: any) => (fil?.key && !fil?.omit && fil?.isExport))?.map((obj) => obj.key);
        const pdfColumns = columns?.filter((fil: any) => (fil?.key && !fil?.omit && fil?.isExport))?.map((obj) => obj.name);
        const rows = supplierList?.map((obj: any) => keys?.map((key: any) => obj[key]))
        generatePDF(pdfColumns, rows, "SightseeingMaster", "Sightseeing Master", "l")
    }

    const ExportToExcel = () => {
        const dispalyname = columns?.filter((fil: any) => !fil?.omit && fil?.key && fil?.isExport)?.map((obj) => obj?.name);
        const fields = columns?.filter((fil: any) => !fil?.omit && fil?.key && fil?.isExport)?.map((obj) => obj?.key);
        ExportExcel(dispalyname, fields, supplierList, "SupplierMaster", "SupplierMaster.xls");
    }

    return (
        <>
            <div className="mx-2 mt-0 mb-3 heading_color">
                <h2 className='fw-bold'> Supplier Management </h2>
            </div>
            <div className="m-2 heading_color">
                <h4>Supplier List</h4>
            </div>
            <div className="m-2">
                <form action="" className='mt-3'>
                    <div className="d-flex justify-content-start">
                        <button type="button" disabled={!userRights?.URightAdd} className="btn btn-primary" id="btnAdd" onClick={handleOpen} > + Create Supplier</button>
                    </div>
                    <br />
                    {/* <div className="filter_with_CTA_btn d-sm-flex d-block">
                        <div className='mt-3 text-center'>
                            <button type="button" className='btn btn-primary' onClick={() => setExportOpen(true)} > Export </button>
                        </div>
                    </div> */}
                    <CommonFilter
                        filtercolumns={columns}
                        filteritems={filteritems}
                        setFilterList={setSupplierList}
                        getdata={getallsupplier}
                        serchdisable={false}
                        setSearchValue={setSearchValue}
                        searchvalue={searchvalue}
                        setSerachBy={setSerachBy}
                        searchby={searchby}
                    />
                    <CustomTable
                        className={"last_two_column_freeze"}
                        columns={columns}
                        data={supplierList}
                        PdfExport={PdfExport}
                        ExportToExcel={ExportToExcel}
                        disabled={!userRights?.URightExport}
                    />
                </form>
            </div >
        </>
    )
}

export default SupplierList